// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1oKX6","resize":"styles_resize__1Nnd-","children":"styles_children__3kSk0","tooltip":"styles_tooltip__NIfId"};